module.exports = __webpack_public_path__ + "static/media/mode0.205f50d5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode0.gif
// module id = 1438
// module chunks = 110